<div *ngIf="permissionAccess">
    <div class="row">
        <div class="col-lg-12">
            <h1>Enviar campañas email</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card>
                <mat-card-content>
                    <h3>Solo acepta archivos csv.</h3>
                    <mat-checkbox class="" [(ngModel)]="check_email_campaign">Email <i class="fa fa-envelope-o fa-lg ml-2" aria-hidden="true"></i></mat-checkbox>
                    <mat-checkbox class="ml-3" [(ngModel)]="check_whatsapp_campaign"> Whatsapp<i class="fa fa-whatsapp fa-lg ml-2" aria-hidden="true"></i></mat-checkbox>
                    <mat-form-field  class="ml-3" appearance="outline">
                        <mat-label>Sender</mat-label>
                        <mat-select  required [(ngModel)]="senderSelected">
                          <mat-option *ngFor="let sender of senders" [value]="sender">{{sender}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    <mat-form-field appearance="outline" class="ml-3">
                        <mat-label>Proveedor</mat-label>
                        <mat-select [(ngModel)]="providerCodeCampaign">
                            <mat-option *ngFor="let partner of partners" [value]="partner.code">{{partner.name}}</mat-option>
                        </mat-select>
                    </mat-form-field> <br>
                    <mat-accordion>
                        <mat-expansion-panel hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Asegurarse que el archivo contenga los siguientes campos
                                </mat-panel-title>
                                <mat-panel-description>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <p class="text-muted">Cliente Id,
                                Num Contrato,
                                Oportunidad Nombre,
                                Estatus del contrato,
                                Merchant User Id,
                                Ultimo Pago,
                                Day of Expiration Date,
                                Vencido,
                                Saldo Insoluto Capital Ajustado,
                                Proporción de repago,
                                Proporción de plazo transcurrido,
                                (Prop. de repago / Prop. de plazo ),
                                Monto Preaprobado,
                                Payback,
                                Total Pago Recibido,
                                Min. Por pagar,
                                Min. Capital Pendiente,
                                Días para vencimiento,
                                Sum of Días desde último pago,
                                Categoría,
                                Acción,
                                Comentarios,
                                funded_by
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div class="row mt-3 mb-2">
                        <div class="col-lg-12">
                            
                            <input type="file" class="upload" (change)="onFileSelected($event)">
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-lg-12">
            <button class="btn btn-sm btn-success" (click)="send()">Enviar campaign</button>
        </div>
    </div>

    <hr class="mt-3 mb-3">
    <!-- =========================================MRP============================================ -->
    <div class="row">
        <div class="col-lg-12">
            <h1>Enviar ofertas Proveedores</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card>
                <mat-card-content>
                    
                    <mat-form-field appearance="outline">
                        <mat-label>Proveedor</mat-label>
                        <mat-select [(ngModel)]="partnerCode">
                            <mat-option *ngFor="let partner of partners" [value]="partner.code">{{partner.name}}</mat-option>
                        </mat-select>
                    </mat-form-field> <br>

                    <mat-checkbox class="" [(ngModel)]="check_email">Email <i class="fa fa-envelope-o fa-lg ml-2"
                            aria-hidden="true"></i></mat-checkbox>
                    <mat-checkbox class="ml-3" [(ngModel)]="check_whatsapp">Whatsapp<i class="fa fa-whatsapp fa-lg ml-2"
                            aria-hidden="true"></i></mat-checkbox>
                    
                    <div class="row mt-2 mb-2">
                        <div class="col-lg-12">
                            <input type="file" class="upload" (change)="onFileSelectedOffer($event)">
                        </div>
                    </div>
                      
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-lg-2">
            <button class="btn btn-sm btn-success" (click)="sendOffers()">Enviar oferta</button>
        </div>
    </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>